class WAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.slides = Array.from(this.querySelectorAll('.w-announcement-bar__slide'));
    this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

    this.fitSlides();
    window.addEventListener('resize', () => this.onResize(), { signal });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (!signal.aborted) this.fitSlides();
      });
    }

    if (this.slides.length <= 1) {
      this.setActive(0);
      return;
    }

    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.querySelector('[data-direction="prev"]')?.addEventListener('click', () => this.select(this.index - 1), { signal });
    this.querySelector('[data-direction="next"]')?.addEventListener('click', () => this.select(this.index + 1), { signal });

    this.addEventListener('pointerenter', () => this.stop(), { signal });
    this.addEventListener('pointerleave', () => this.start(), { signal });
    this.addEventListener('focusin', () => this.stop(), { signal });
    this.addEventListener('focusout', () => this.start(), { signal });
    document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()), { signal });

    this.setActive(this.index);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    if (this.rafId) cancelAnimationFrame(this.rafId);
    this.controller?.abort();
  }

  onResize() {
    if (this.rafId) return;
    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;
      this.fitSlides();
    });
  }

  fitSlides() {
    const wrap = this.querySelector('.w-announcement-bar__slides');
    if (!wrap) return;
    const available = wrap.clientWidth;
    if (available <= 0) return;
    const range = document.createRange();
    this.slides.forEach((slide) => {
      slide.style.fontSize = '';
      range.selectNodeContents(slide);
      const needed = range.getBoundingClientRect().width;
      if (needed > available) {
        const base = parseFloat(getComputedStyle(slide).fontSize);
        const fitted = Math.max(1, Math.floor(base * available / needed));
        slide.style.fontSize = fitted + 'px';
      }
    });
  }

  select(next) {
    const count = this.slides.length;
    this.index = ((next % count) + count) % count;
    this.setActive(this.index);
  }

  setActive(active) {
    this.slides.forEach((slide, i) => {
      const isActive = i === active;
      slide.classList.toggle('is-active', isActive);
      slide.inert = !isActive;
    });
  }

  start() {
    if (!this.autoplay || this.reducedMotion || this.timer) return;
    this.timer = setInterval(() => this.select(this.index + 1), this.speed);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }
}

customElements.define('w-announcement-bar', WAnnouncementBar);
